/* =====================================================================
   9/23/26 — PRODUCT PAGE "ALSO GUARANTEED TO FIT YOUR VEHICLE" 
   Replaces the boxed "Other items you may like" slider on desktop with a
   full-width row of bulbs that the fitment database lists for the shopper's
   vehicle (same data + naming rules as the cart drawer suggestions, see
   snippets/cdx-vehicle-fit.liquid and snippets/cart-drawer.liquid).
   - No vehicle yet: shows the product's usual companion products instead.
   - Skips this product and anything already in the cart.
   - Runs on desktop and phones (phone layout lives in custom.css).
   Loaded on product pages by snippets/cdx-vehicle-fit.liquid (a deferred script tag).
   ===================================================================== */
(function () {
  if (window.__cdxProductFits) return;
  window.__cdxProductFits = true;
  if (!document.body.classList.contains('product')) return;

  var SKIP_HANDLES = { 'unfortunately-we-do-not-have-a-product-for-your-application': 1 };
  var MAX_PRODUCTS = 20;
  var here = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
  here = decodeURIComponent(here).toLowerCase();

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function fetchJson(url) { return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function fitState() { try { return window.__cdxFit ? window.__cdxFit.current() : { status: 'none' }; } catch (e) { return { status: 'none' }; } }

  function fromCollectionJson(p) {
    var variants = (p.variants || []).map(function (v) {
      var cap = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
      return { id: v.id, price: Math.round(parseFloat(v.price) * 100), compare_at_price: cap || null, available: !!v.available };
    });
    var img = (p.images && p.images[0] && p.images[0].src) || null;
    return { id: p.id, handle: p.handle, title: p.title, featured_image: img, variants: variants,
      available: variants.some(function (v) { return v.available; }) };
  }
  function usable(p) { return p && p.available && p.handle && !SKIP_HANDLES[p.handle] && p.variants && p.variants.length && p.handle.toLowerCase() !== here; }

  /* ---- Naming by job on the vehicle (same rules as the cart drawer) ---- */
  function locLabel(raw) {
    var u = String(raw || '').toUpperCase().replace(/[^A-Z0-9\/ ]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!u || /ALL BULBS/.test(u)) return null;
    var pos = '';
    if (/\bINNER\b/.test(u)) pos = ' (Inner)';
    else if (/\bOUTER\b/.test(u)) pos = ' (Outer)';
    else if (/\bUPPER\b/.test(u)) pos = ' (Upper)';
    else if (/\bLOWER\b/.test(u)) pos = ' (Lower)';
    var front = /\bFRONT\b/.test(u), rear = /\bREAR\b|\bR$/.test(u);
    if (/HEA[DT]*\s*L/.test(u) || /HEADL/.test(u)) {
      if (/DRL/.test(u)) return 'Headlight High Beam / DRL';
      if (/HIGH.*LOW|DUAL|LOW.*HIGH/.test(u)) return 'Headlight High/Low Beam';
      if (/HIGH/.test(u)) return 'Headlight High Beam';
      if (/LOW|LWO/.test(u)) return 'Headlight Low Beam';
      return 'Headlights';
    }
    if (/THIRD|3RD/.test(u)) return '3rd Brake Light';
    if (/LIC|LCIENSE/.test(u)) return 'License Plate Lights';
    if (/REVERSE|BACK ?UP/.test(u)) return 'Reverse Lights' + pos;
    if (/BR[EA]A?KE?/.test(u)) return 'Brake Lights' + pos;
    if (/TAIL/.test(u)) return 'Tail Lights' + pos;
    if (/TURN|BLINKER|SIGNAL/.test(u)) return (rear ? 'Rear' : 'Front') + ' Turn Signals';
    if (/ROOF/.test(u)) return 'Roof Marker Lights';
    if (/MARK/.test(u)) return (rear ? 'Rear ' : (front ? 'Front ' : '')) + 'Side Markers';
    if (/PA+RKING/.test(u)) return 'Parking Lights';
    if (/FOG/.test(u)) return (rear ? 'Rear ' : '') + 'Fog Lights';
    if (/DAYTIME|DRL/.test(u)) return 'Daytime Running Lights';
    if (/CORNER|CONERING/.test(u)) return 'Cornering Lights';
    if (/CARGO|TRUNK/.test(u)) return 'Cargo / Trunk Light';
    if (/MAP/.test(u)) return (rear ? 'Rear ' : '') + 'Map Lights';
    if (/DOME/.test(u)) return 'Dome Light';
    if (/COURTESY/.test(u)) return 'Courtesy Lights';
    if (/GLOVE|GOLVE/.test(u)) return 'Glove Box Light';
    if (/PUDDLE/.test(u)) return 'Puddle Lights';
    if (/READING/.test(u)) return (rear ? 'Rear ' : '') + 'Reading Lights';
    if (/MIRROR/.test(u)) return 'Door Mirror Lights';
    if (/INTERIOR DOOR|DOOR/.test(u)) return 'Interior Door Lights';
    if (/FOOTWELL/.test(u)) return 'Footwell Lights';
    if (/STEPWELL|STEP/.test(u)) return 'Step Lights';
    if (/ENGINE/.test(u)) return 'Engine Compartment Light';
    if (/CONSOLE/.test(u)) return 'Floor Console Light';
    if (/INSTRUMENT|DASH|GAUGE/.test(u)) return 'Instrument Panel Lights';
    if (/VANITY/.test(u)) return 'Vanity Lights';
    var t = u.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
    if (!/light/i.test(t)) t += ' Lights';
    return t;
  }
  function titleLabel(title) {
    var t = String(title || '');
    if (/license plate/i.test(t)) return 'License Plate Lights';
    if (/cargo/i.test(t)) return 'Cargo Lights';
    if (/3rd brake|third brake/i.test(t)) return '3rd Brake Light';
    if (/reverse/i.test(t)) return 'Reverse Lights';
    if (/headlight.*fog|fog.*headlight/i.test(t)) return 'Headlight + Fog Light Package';
    if (/headlight/i.test(t)) return 'Headlights';
    if (/fog/i.test(t)) return 'Fog Lights';
    if (/anti.?flicker|canbus|decoder/i.test(t)) return 'Anti-Flicker Decoder';
    if (/parts bag/i.test(t)) return 'Parts Bag';
    if (/puddle/i.test(t)) return 'Puddle Lights';
    if (/mirror/i.test(t)) return 'Mirror Blinker Housings';
    if (/gift card/i.test(t)) return 'Gift Card';
    var m = t.match(/\(([^)]*)\)/);
    if (m && !/lumen/i.test(m[1])) {
      var job = m[1].replace(/\s+/g, ' ').trim();
      var col = (t.match(/\b(amber|red|white|switchback|blue|green)\b/i) || [])[1];
      col = col ? col.charAt(0).toUpperCase() + col.slice(1).toLowerCase() + ' ' : '';
      job = job.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
      if (/blinker|signal/i.test(job)) return col + job.replace(/\s*\/\s*/g, ' / ');
      return col + job.replace(/\s*\/\s*/g, ' / ') + ' Lights';
    }
    return t;
  }
  function mergeSameSocket(labels) {
    var out = labels.slice();
    function has(x) { return out.indexOf(x) !== -1; }
    function drop(x) { out.splice(out.indexOf(x), 1); }
    function swap(a, b, c) { if (has(a) && has(b)) { out[out.indexOf(a)] = c; drop(b); } }
    swap('Tail Lights', 'Brake Lights', 'Tail / Brake Lights');
    swap('Headlight High Beam', 'Headlight Low Beam', 'Headlight High/Low Beam');
    swap('Headlight High Beam', 'Daytime Running Lights', 'Headlight High Beam / DRL');
    swap('Front Turn Signals', 'Parking Lights', 'Front Turn Signal / Parking Lights');
    swap('Rear Turn Signals', 'Parking Lights', 'Rear Turn Signal / Parking Lights');
    return out;
  }
  var LABEL_ORDER = [
    /reverse/i,
    /headlight low beam|headlight high\/low|headlight \+ fog|headlights$/i,
    /brake/i,
    /turn signal|blinker/i,
    /fog/i,
    /headlight high beam/i,
    /tail/i,
    /license plate/i,
    /cargo/i,
    /parking/i,
    /side marker|roof marker|cornering|daytime/i,
    /dome|map|courtesy|footwell|glove|reading|door|vanity|instrument|console|step|engine|puddle/i
  ];
  function labelRank(label) {
    if (/3rd brake/i.test(label)) return 2.5;
    for (var i = 0; i < LABEL_ORDER.length; i++) { if (LABEL_ORDER[i].test(label)) return i; }
    return LABEL_ORDER.length;
  }

  function entriesFor(list, vehicleKnown) {
    var out = [];
    if (!vehicleKnown) {
      list.forEach(function (p) { out.push({ p: p, key: p.handle, label: p.title, sub: '' }); });
      return out;
    }
    var byLabel = {};
    list.forEach(function (p) {
      var labels = [];
      (p._locs || []).forEach(function (r) { var L = locLabel(r); if (L && labels.indexOf(L) === -1) labels.push(L); });
      if (!labels.length) labels.push(titleLabel(p.title));
      mergeSameSocket(labels).forEach(function (L) {
        var e = { p: p, key: p.handle + '|' + L, label: L, sub: p.title };
        out.push(e);
        (byLabel[L] = byLabel[L] || []).push(e);
      });
    });
    out.forEach(function (e, n) { e._rank = labelRank(e.label); e._n = n; });
    out.sort(function (a, b) { return (a._rank - b._rank) || (a._n - b._n); });
    return out;
  }

  /* ---- Data ---- */
  /* Live prices / stock for many products in ONE request (templates/search.cdxpf.liquid).
     Nothing about price or stock is ever saved in the browser. */
  function liveProducts(handles, cols) {
    var parts = [];
    for (var i = 0; i < handles.length; i += 20) {
      parts.push(handles.slice(i, i + 20).map(function (h) { return 'p.' + h; }));
    }
    if (cols.length) {
      if (!parts.length) parts.push([]);
      parts[0] = parts[0].concat(cols.map(function (c) { return 'c.' + c; }));
    }
    if (!parts.length) return Promise.resolve([]);
    return Promise.all(parts.map(function (q) {
      return fetch('/search?view=cdxpf&q=' + encodeURIComponent(q.join(',')))
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t).products || []; });
    })).then(function (lists) { return [].concat.apply([], lists); });
  }

  function cartIds() {
    return fetchJson('/cart.js').then(function (c) {
      var ids = {};
      ((c && c.items) || []).forEach(function (i) { ids[i.product_id] = 1; });
      return ids;
    });
  }

  function mergeFit(lists) {
    var seen = {}, all = [];
    lists.forEach(function (l) {
      l.forEach(function (x) {
        if (!usable(x)) return;
        if (seen[x.id]) {
          x._locs.forEach(function (L) { if (seen[x.id]._locs.indexOf(L) === -1) seen[x.id]._locs.push(L); });
          return;
        }
        seen[x.id] = x; all.push(x);
      });
    });
    return all.slice(0, MAX_PRODUCTS);
  }

  function fitProducts(fit) {
    var locs = fit.locs || {};
    function tag(x, id) { x._locs = (locs[id] || []).slice(); return x; }
    return liveProducts(fit.products, fit.collections).then(function (list) {
      return mergeFit([list.map(function (x) { return tag(x, String(x.src || '').replace(/^([pc])\./, '$1:')); })]);
    }).catch(function () {
      /* Fallback (feed missing): ask for each product separately, like before */
      var jobs = fit.products.map(function (h) { return fetchJson('/products/' + h + '.js').then(function (x) { return x ? [tag(x, 'p:' + h)] : []; }); })
        .concat(fit.collections.map(function (c) {
          return fetchJson('/collections/' + c + '/products.json?limit=250').then(function (j) {
            return (j && j.products ? j.products : []).map(fromCollectionJson).map(function (x) { return tag(x, 'c:' + c); });
          });
        }));
      return Promise.all(jobs).then(mergeFit);
    });
  }

  function companionProducts() {
    var hs = [];
    document.querySelectorAll('.companion-products a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (m && hs.indexOf(m[1]) === -1) hs.push(m[1]);
    });
    return liveProducts(hs, []).then(function (l) { return l.filter(usable); }).catch(function () {
      return Promise.all(hs.map(function (h) { return fetchJson('/products/' + h + '.js'); }))
        .then(function (l) { return l.filter(usable); });
    });
  }

  function vehicleName(fit) {
    try {
      var c = JSON.parse(localStorage.getItem('cdxHeaderVehicle'));
      if (c && c.v) return c.v;
    } catch (e) {}
    return String(fit.label || '').toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
  }

  /* ---- Rendering ---- */
  var ICON_L = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
  var ICON_FIT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';

  function cardHtml(e, vehicleKnown) {
    var p = e.p;
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var img = p.featured_image || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img && !/[?&]width=/.test(img)) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=500';
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var price = '<span class="cdxpf-now' + (onSale ? ' is-sale' : '') + '">' + fmt(v.price) + '</span>' +
      (onSale ? '<s class="cdxpf-was">' + fmt(v.compare_at_price) + '</s>' : '');
    return '<div class="cdxpf-card" role="listitem">' +
      '<a class="cdxpf-media" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="cdxpf-body">' +
        (vehicleKnown ? '<div class="cdxpf-fit">' + ICON_FIT + '<span>Fits your vehicle</span></div>' : '') +
        '<a class="cdxpf-name" href="/products/' + esc(p.handle) + '">' + esc(e.label) + '</a>' +
        (vehicleKnown && e.sub ? '<div class="cdxpf-sub">' + esc(e.sub) + '</div>' : '') +
        '<div class="cdxpf-price">' + price + '</div>' +
        '<button type="button" class="cdxpf-add" data-cdxpf-add="' + v.id + '">Add to cart</button>' +
      '</div></div>';
  }

  var root = null;
  function mount() {
    if (root) return root;
    var main = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if (!main) {
      var comp = document.querySelector('.companion-container');
      main = comp ? comp.closest('.shopify-section') : null;
    }
    if (!main) return null;
    root = document.createElement('section');
    root.className = 'cdxpf';
    root.setAttribute('aria-label', 'Recommended products');
    root.hidden = true;
    root.innerHTML =
      '<div class="cdxpf-inner">' +
        '<div class="cdxpf-head">' +
          '<div><h2 class="cdxpf-title h3"></h2><p class="cdxpf-note"></p></div>' +
          '<div class="cdxpf-nav"><button type="button" class="cdxpf-arrow" data-cdxpf-prev aria-label="Previous products">' + ICON_L + '</button>' +
          '<button type="button" class="cdxpf-arrow" data-cdxpf-next aria-label="More products">' + ICON_R + '</button></div>' +
        '</div>' +
        '<div class="cdxpf-track" role="list"></div>' +
      '</div>';
    main.parentNode.insertBefore(root, main.nextSibling);
    root.addEventListener('click', onClick);
    root.querySelector('.cdxpf-track').addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    return root;
  }

  function syncArrows() {
    if (!root) return;
    var t = root.querySelector('.cdxpf-track');
    var max = t.scrollWidth - t.clientWidth - 2;
    root.querySelector('[data-cdxpf-prev]').disabled = t.scrollLeft <= 2;
    root.querySelector('[data-cdxpf-next]').disabled = t.scrollLeft >= max;
    root.querySelector('.cdxpf-nav').hidden = max <= 0;
  }

  function onClick(e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var track = root.querySelector('.cdxpf-track');
    if (t.closest('[data-cdxpf-prev]')) { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); return; }
    if (t.closest('[data-cdxpf-next]')) { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); return; }
    var btn = t.closest('[data-cdxpf-add]');
    if (btn) addToCart(btn);
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: parseInt(btn.getAttribute('data-cdxpf-add'), 10), quantity: 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
  }

  var renderedSig = null;
  function run() {
    var fit = fitState();
    if (fit.status === 'pending') return; // wait for the "cdx:fit" event
    var vehicleKnown = fit.status === 'ready';
    var sig = vehicleKnown ? 'fit:' + fit.key : 'none';
    if (sig === renderedSig) return;
    renderedSig = sig;
    var r = mount();
    if (!r) { document.body.classList.add('cdxpf-none'); return; }
    Promise.all([vehicleKnown ? fitProducts(fit) : companionProducts(), cartIds()]).then(function (res) {
      if (renderedSig !== sig) return;
      var inCart = res[1];
      var list = res[0].filter(function (p) { return !inCart[p.id]; });
      var entries = entriesFor(list, vehicleKnown);
      if (!entries.length) { r.hidden = true; document.body.classList.remove('cdxpf-on'); document.body.classList.add('cdxpf-none'); return; }
      r.querySelector('.cdxpf-title').textContent = vehicleKnown
        ? 'Also guaranteed to fit your ' + vehicleName(fit)
        : 'You may also like';
      r.querySelector('.cdxpf-note').textContent = vehicleKnown
        ? 'Every bulb below is listed for your vehicle in our fitment database.'
        : 'Add your vehicle at the top of the page to see bulbs that are guaranteed to fit.';
      r.querySelector('.cdxpf-track').innerHTML = entries.map(function (e) { return cardHtml(e, vehicleKnown); }).join('');
      r.querySelector('.cdxpf-track').scrollLeft = 0;
      r.hidden = false;
      document.body.classList.remove('cdxpf-none');
      document.body.classList.add('cdxpf-on');
      syncArrows();
    });
  }

  function start() {
    /* custom.css holds blank space for this row while it loads; let it go if nothing shows up */
    setTimeout(function () { if (!document.body.classList.contains('cdxpf-on')) document.body.classList.add('cdxpf-none'); }, 12000);
    run();
    document.addEventListener('cdx:fit', function () { renderedSig = null; run(); });
    var n = 0, iv = setInterval(function () { run(); if (++n > 20) clearInterval(iv); }, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
